/*
 * Two collection-page behaviours that belong to the shop rather than to the
 * theme's stock filtering:
 *
 * 1. Sorting oldest-first switches "Auf Lager" on. The oldest stock is also
 *    the most picked-over — at the time of writing this collection had 263
 *    items in stock against 864 sold out — so the unfiltered oldest-first list
 *    is almost entirely unavailable products.
 *
 * 2. Going back from a product returns to the product you left from.
 *
 *    The anchor is the clicked product, not a pixel offset: card heights
 *    depend on image size, title length and viewport, so replaying an offset
 *    can land a row or two off. The offset is still recorded, but only to put
 *    that product back at the same height on screen.
 *
 *    Only as many pages are reloaded as it takes to reach that product, not
 *    everything that had been scrolled through — coming back to the third row
 *    costs one request, not six.
 */
(function () {
  var POSITION_KEY = 'onhowCollectionPosition';
  var POSITION_MAX_AGE_MS = 30 * 60 * 1000;
  var OLDEST_FIRST = 'created-ascending';
  var AVAILABILITY = 'filter.v.availability';

  function productGrid() {
    return document.querySelector('#product-grid, #main-collection-product-grid, .ProductListWrapper, .product-list');
  }

  function onCollectionPage() {
    return Boolean(productGrid());
  }

  /* ------------------------------------------------------------------ *
   * 1. Oldest first implies in stock
   * ------------------------------------------------------------------ */

  // Every copy of the checkbox is ticked, not just the one in the form that
  // changed: the desktop layout keeps the sort select in #FacetSortForm and
  // the availability boxes in #FacetFiltersForm, and the theme serialises both
  // of those together. Ticking a box in a form that is not serialised is
  // harmless, so this stays correct for the mobile drawer too.
  function requireInStock() {
    var boxes = document.querySelectorAll('input[name="' + AVAILABILITY + '"][value="1"]');
    boxes.forEach(function (box) {
      box.checked = true;
    });
  }

  // Capture phase, so the box is ticked before the theme's own (debounced)
  // handler serialises the form. Setting .checked in script fires no event of
  // its own, so this cannot trigger a second submit.
  function onSortInteraction(event) {
    var field = event.target;
    if (!field || field.name !== 'sort_by') return;
    if (field.value !== OLDEST_FIRST) return;
    requireInStock();
  }

  document.addEventListener('input', onSortInteraction, true);
  document.addEventListener('change', onSortInteraction, true);

  // Same rule for a URL opened directly (a shared or bookmarked link). Only
  // when the address carries no filters at all — once the visitor has chosen
  // any filter themselves, including deliberately unticking "Auf Lager", that
  // choice is left alone.
  function applySortRuleToUrl() {
    if (!onCollectionPage()) return;
    var params = new URLSearchParams(window.location.search);
    if (params.get('sort_by') !== OLDEST_FIRST) return;

    var carriesFilter = false;
    params.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0) carriesFilter = true;
    });
    if (carriesFilter) return;

    params.set(AVAILABILITY, '1');
    window.location.replace(window.location.pathname + '?' + params.toString());
  }

  /* ------------------------------------------------------------------ *
   * 2. Back from a product lands on that product
   * ------------------------------------------------------------------ */

  function currentAddress() {
    return window.location.pathname + window.location.search;
  }

  function handleFromHref(href) {
    var match = /\/products\/([^/?#]+)/.exec(href || '');
    return match ? match[1] : '';
  }

  function cards() {
    var grid = productGrid();
    return grid ? Array.prototype.slice.call(grid.children) : [];
  }

  function store(entry) {
    try {
      sessionStorage.setItem(POSITION_KEY, JSON.stringify(entry));
    } catch (error) {
      /* private mode or storage full — returning to the spot is a nicety */
    }
  }

  function rememberProduct(link) {
    if (!onCollectionPage()) return;

    var handle = handleFromHref(link.getAttribute('href'));
    if (!handle) return;

    var card = link.closest('li') || link.closest('.grid__item') || link;
    var all = cards();
    var index = all.indexOf(card);
    var scroller = document.querySelector('infinite-scroll');
    var loadedPages = scroller && scroller.page ? scroller.page : 1;

    // How far in the grid this product sits, expressed in pages, so the way
    // back only refetches up to it. all.length / loadedPages is the page size
    // the collection actually rendered rather than an assumed one.
    var perPage = loadedPages > 0 ? Math.round(all.length / loadedPages) : all.length;
    var pagesNeeded = perPage > 0 && index >= 0 ? Math.ceil((index + 1) / perPage) : loadedPages;

    store({
      url: currentAddress(),
      handle: handle,
      offset: Math.round(card.getBoundingClientRect().top),
      y: Math.round(window.scrollY),
      pages: Math.max(1, Math.min(pagesNeeded, loadedPages)),
      at: Date.now(),
    });
  }

  function rememberScrollOnly() {
    if (!onCollectionPage()) return;
    var scroller = document.querySelector('infinite-scroll');
    var existing = null;
    try {
      existing = JSON.parse(sessionStorage.getItem(POSITION_KEY) || 'null');
    } catch (error) {
      existing = null;
    }
    // A product click already recorded something better; don't overwrite it.
    if (existing && existing.handle && existing.url === currentAddress() && Date.now() - existing.at < 5000) return;

    store({
      url: currentAddress(),
      handle: '',
      offset: 0,
      y: Math.round(window.scrollY),
      pages: scroller && scroller.page ? scroller.page : 1,
      at: Date.now(),
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest && event.target.closest('a[href*="/products/"]');
      if (link) rememberProduct(link);
    },
    true
  );
  window.addEventListener('pagehide', rememberScrollOnly);

  function findCard(handle) {
    if (!handle) return null;
    var grid = productGrid();
    if (!grid) return null;
    var link = grid.querySelector('a[href*="/products/' + handle + '"]');
    return link ? link.closest('li') || link.closest('.grid__item') || link : null;
  }

  function settleOn(getTarget) {
    var attempts = 0;

    function step() {
      var target = getTarget();
      if (target === null) return;
      window.scrollTo(0, Math.max(0, target));
      attempts += 1;
      // Images below the fold arrive after the markup and each one that lands
      // changes the document height, so the first jump usually falls short.
      if (attempts < 15) window.requestAnimationFrame(step);
    }

    step();
    window.setTimeout(step, 200);
    window.setTimeout(step, 600);
  }

  function scrollToSaved(saved) {
    var card = findCard(saved.handle);
    if (card) {
      settleOn(function () {
        var rect = card.getBoundingClientRect();
        return rect.top + window.scrollY - saved.offset;
      });
    } else if (saved.y) {
      settleOn(function () {
        return saved.y;
      });
    }
  }

  function restore() {
    if (!onCollectionPage()) return;

    var raw = null;
    try {
      raw = sessionStorage.getItem(POSITION_KEY);
    } catch (error) {
      return;
    }
    if (!raw) return;

    try {
      sessionStorage.removeItem(POSITION_KEY);
    } catch (error) {
      /* nothing to do */
    }

    var saved;
    try {
      saved = JSON.parse(raw);
    } catch (error) {
      return;
    }

    if (!saved || saved.url !== currentAddress()) return;
    if (Date.now() - saved.at > POSITION_MAX_AGE_MS) return;
    if (!saved.handle && !saved.y) return;

    if (findCard(saved.handle)) {
      scrollToSaved(saved);
      return;
    }

    var scroller = document.querySelector('infinite-scroll');
    if (scroller && typeof scroller.loadUpTo === 'function' && saved.pages > 1) {
      scroller.loadUpTo(saved.pages).then(function () {
        scrollToSaved(saved);
      });
    } else {
      scrollToSaved(saved);
    }
  }

  if (onCollectionPage() && 'scrollRestoration' in window.history) {
    // The browser would otherwise restore its own idea of the offset against a
    // document that is still one page long, and fight the restore above.
    window.history.scrollRestoration = 'manual';
  }

  // Both paths matter. A page served from the back/forward cache keeps every
  // product that had been loaded — but because scroll restoration is set to
  // manual above, the browser will not put the offset back either, so this has
  // to run there too. That was the hole: bailing out on persisted meant a
  // cached page came back sitting at the top.
  window.addEventListener('pageshow', function () {
    restore();
  });

  applySortRuleToUrl();
})();
